<template>
<v-container fluid>
  <v-card>
    <v-card-title>
        <v-row>
          <v-col cols="12" sm="6" md="3">
          <v-row>
          <v-col cols="8">
            <h6>Trains Running Late</h6>
          </v-col>
          <v-col>
            <v-btn text icon color="purple" dark @click.native.stop="initialize()">
              <v-icon dark>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
          </v-row>
        </v-col>
          <v-col cols="12" sm="6" md="3">
            <span class="body-2 font-weight-black">Last update: {{train_date}} </span>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-slider v-model="late_run_mnt" class="align-center" :max="max" :min="min" hide-details>
              <template v-slot:append>
                <v-text-field v-model="late_run_mnt" class="mt-0 pt-0" hide-details single-line type="number"></v-text-field>
              </template>
            </v-slider>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
    </v-card-title>
    <v-data-table :headers="headers" :items="trains" :search="search" :footer-props="{
    'items-per-page-options': [10, 20, 30, 40, 50]
    }" :items-per-page="40" sort-by="trains" class="elevation-1" @click:row="onRowClick($event)"
     :loading="isLoading" loading-text="Loading... Please wait" :mobile-breakpoint="100">

      <template v-slot:item.train_date="{ item }">
        {{getFormattedDate(item.train_date)}}
      </template>

      <template v-slot:item.arr="{ item }">
        {{getFormattedTime(item.arr)}}
      </template>

      <template v-slot:item.dep="{ item }">
        {{getFormattedTime(item.dep)}}
      </template>

      <template v-slot:item.last_stn_late_arr="{ item }">
        {{getFormattedTimeSec(item.last_stn_late_arr)}}
      </template>

      <template v-slot:item.last_stn_late_dep="{ item }">
        {{getFormattedTimeSec(item.last_stn_late_dep)}}
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">No Report, click to retry</v-btn>
      </template>
    </v-data-table>
  </v-card>
</v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'

export default {
  name: 'LateRunTrains',
  data() {
    return {
      search: '',
      valid: false,
      dateRules: [v => !!v || 'Date is required'],
      errors: [],
      headers: [{
          text: 'Train Date',
          align: 'left',
          sortable: true,
          value: 'train_date',
        },
        {
          text: 'Train No',
          align: 'left',
          sortable: true,
          value: 'train_no',
        },
        {
          text: 'Rake No',
          align: 'left',
          sortable: true,
          value: 'device_name',
        },
        {
          text: 'ORG',
          value: 'org'
        },
        {
          text: 'Sch Dep.',
          value: 'dep'
        },
        {
          text: 'DEST',
          value: 'dest'
        },
        {
          text: 'Sch Arr.',
          value: 'arr'
        },
        {
          text: 'Staion',
          align: 'left',
          sortable: false,
          value: 'last_stn_code',
        },
        {
          text: 'Act Arr',
          sortable: false,
          value: 'last_stn_arr'
        },
        {
          text: 'Late in',
          value: 'last_stn_late_arr'
        },
        {
          text: 'Act dep',
          sortable: false,
          value: 'last_stn_dep'
        },
        {
          text: 'Late Out',
          value: 'last_stn_late_dep'
        },

      ],
      train: {},
      train_loading: false,
      trains: [],
      train_date: moment().format('DD/MM/YYYY HH:mm:ss'),
      isLoading: false,
      late_run_mnt: 4,
      min: -10,
      max: 60,
      lastupdate: moment().format('HH:mm:ss'),
      lastupdate_relative: moment().fromNow(),
      fetchTimer: null
    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep', 'actDep', 'actArr']),
  },

  created() {

    this.initialize()
  },

  mounted() {
    this.fetchTimer = setInterval(() => this.initialize(), 60000);
  },

  destroyed() {
    clearInterval(this.fetchTimer);
  },
  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr']),
    initialize() {

      //      this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
      //      console.log(this.curDeviceId)
      this.isLoading = true

      var p = {
        // start_time: moment('2019-10-17 22:00:00').format('YYYY-MM-DD HH:mm:ss'),
        start_time: moment().format('YYYY-MM-DD HH:mm:ss'),
        late_run_mnt: this.late_run_mnt
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/laterun`, {
          params: p
        })
        .then(response => {
          this.trains = []
          this.trains = response.data
          this.isLoading = false
          this.train_date = moment().format('DD/MM/YYYY HH:mm:ss')
          //    console.log(response.data);
        })
        .catch(e => {
          this.errors.push(e)
          if (e.response.status === 401) {
            this.$router.push({
              name: 'Login'
            })
          }
        })
    },

    refreshData() {

    },

    //update traccar_db.device_train_map set dep = addtime(train_date, time(dep)), arr = addtime(train_date, time(arr));
    //update traccar_db.device_train_map set arr = adddate(arr, 1) where arr < dep;
    onRowClick($event) {
      console.log($event);
      this.updateCurTrainNo($event.train_no)
      this.updateCurTrainDate(moment($event.train_date).format("YYYY-MM-DD"))
      this.updateCurDeviceId($event.device_id)
      this.updateCurDeviceName($event.device_name)
      this.updateCurOrg($event.org)
      this.updateCurDep($event.dep)
      this.updateActDep($event.act_dep)
      this.updateCurDest($event.dest)
      this.updateCurArr($event.arr)
      this.updateActArr($event.act_arr)
      this.$router.push({
        name: 'Positions'
      })
    },
    getFormattedDate(t) {
      var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
      var testDateUtc = moment.utc(lt);
      var localDate = moment(testDateUtc).local();
      return localDate.format("DD/MM/YYYY")
    },
    getFormattedTime(t) {
      return moment.utc(t).format("HH:mm:ss")
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    }
  }
}
</script>
